import React, {Component} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {TableCellTypes} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {IPickupsStore} from '../../mobx-store/storeInterfaces/pickupsStoreInterface';
import {inject, observer} from 'mobx-react';
import {RouteComponentProps} from 'react-router';

interface IProps extends RouteComponentProps {
    pickupsStore: IPickupsStore;
}

@inject('pickupsStore')
@observer
class PickupsScreen extends Component<IProps> {
    addButton: any;
    tableHeader: any = [];
    tableData: any[] = [];
    tableCellTypes: TableCellTypes[] = [];
    title: string;

    constructor(props: IProps) {
        super(props);
        this.title = 'Manage Pickups';
    }

    handleTableButtonCellClicked = (index: string, key: string) => {
            this.props.history.push(`/pickups/${index}/${key}`);
    }

    handelAdd = (): void => {
        this.props.history.push('/pickups/new');
    }

    getAddAdButton = () => {
        return {
            title: 'Add Pickup',
            onAdd: this.handelAdd,
        };
    }

    getAdsTableHeader = () => {
        return [
            {
                title: 'Pickup Name',
            },
            {
                title: 'Pickup fee',
            },
            {
                title: 'Edit',
            }
        ];
    }

    getAdsTableCellTypes = (): TableCellTypes[] => {
        return [
            {
                cellType: 'Text',
                key: 'place',
            },
            {
                cellType: 'Text',
                key: 'fee',
            },
            {
                cellType: 'Button',
                key: 'edit',
                onClick: this.handleTableButtonCellClicked
            }
        ];
    }

    render() {
        const {pickups, loaded} = this.props.pickupsStore;
        this.addButton = this.getAddAdButton();
        this.tableHeader = this.getAdsTableHeader();
        this.tableData = pickups;
        this.tableCellTypes = this.getAdsTableCellTypes();
        return loaded && (
            <div>
                <GeneralTableComponent emptyMessage='There are no pickups added yet'
                                       title={this.title}
                                       tableHeader={this.tableHeader}
                                       tableData={this.tableData}
                                       tableCellTypes={this.tableCellTypes}
                                       addButton={this.addButton}/>
            </div>
        );
    }

    componentDidMount() {
        this.props.pickupsStore.getPickups();
    }

}

export default PickupsScreen;
